<div id="roles-affect-users-dialog">
  <div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-primary">
      <mat-toolbar-row
        fxLayout="column"
        class="dialog-title"
        fxLayoutAlign="space-evenly flex-start">
        <span class="title">
          {{ 'ROLES.AFFECTUSERROLE.TITLE' | translate }}
        </span>
        <span class="title"> {{ selectedRole.displayName }} </span>
      </mat-toolbar-row>
    </mat-toolbar>
    <div mat-dialog-content class="dialog-content">
      <div class="search-section">
        <div class="row search-wrapper">
          <div
            class="search"
            fxFlex
            fxLayout="row"
            fxLayoutAlign="start center">
            <mat-icon>search</mat-icon>
            <input
              autocomplete="on"
              #filter
              [formControl]="firstNameSearchField"
              matInput
              placeholder="{{ 'TABLE.SEARCH.FIRSTNAME' | translate }}" />
          </div>
        </div>
        <div class="row search-wrapper">
          <div
            class="search"
            fxFlex
            fxLayout="row"
            fxLayoutAlign="start center">
            <mat-icon>search</mat-icon>
            <input
              autocomplete="on"
              #filter
              [formControl]="lastNameSearchField"
              matInput
              placeholder="{{ 'TABLE.SEARCH.NAME' | translate }}" />
          </div>
        </div>
      </div>
      @if (isLoading) {
        <div class="loading" fxLayout="column" fxLayoutAlign="center center">
          <div fxFlex="100">
            <mat-progress-spinner
              [color]="spinner.color"
              [mode]="spinner.mode"
              [value]="spinner.value"
              [diameter]="spinner.diameter"></mat-progress-spinner>
          </div>
        </div>
      }
      @if (!isLoading) {
        <div class="mat-elevation-z8">
          <table
            id="gridContainer"
            mat-table
            [dataSource]="dataSource"
            matSort
            (matSortChange)="sortData($event)"
            multiTemplateDataRows>
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  (change)="$event ? toggleAllRows() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()"
                  [aria-label]="checkboxLabel()">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(row) : null"
                  [checked]="selection.isSelected(row)"
                  [aria-label]="checkboxLabel(row)">
                </mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="firstName">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header="firstName"
                class="sortable">
                {{ 'TABLE.ROLES.HEADER.FIRSTNAME' | translate }}
                <mat-icon
                  [style.color]="
                    sortedValue !== 'firstName' ? '#757575' : 'transparent'
                  "
                  class="sort-icon"
                  >sort</mat-icon
                >
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.firstName }}
              </td>
            </ng-container>
            <ng-container matColumnDef="lastName">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header="lastName"
                class="sortable">
                {{ 'TABLE.ROLES.HEADER.LASTNAME' | translate }}
                <mat-icon
                  [style.color]="
                    sortedValue !== 'lastName' ? '#757575' : 'transparent'
                  "
                  class="sort-icon"
                  >sort</mat-icon
                >
              </th>
              <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
            </ng-container>
            <ng-container matColumnDef="username">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'TABLE.ROLES.HEADER.USERNAME' | translate }}
              </th>
              <td mat-cell *matCellDef="let element">{{ element.userName }}</td>
            </ng-container>
            <ng-container matColumnDef="expand">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button (click)="toggleRow(element)">
                  <mat-icon>more_horiz</mat-icon>
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="expandedDetail">
              <td
                mat-cell
                *matCellDef="let element"
                [attr.colspan]="displayedColumns.length">
                @if (expandedElement === element && windowWidth <= 1000) {
                  <div class="expanded-detail">
                    <p>
                      <strong
                        >{{ 'TABLE.ROLES.HEADER.USERNAME' | translate }}:
                      </strong>
                      {{ element.username }}
                    </p>
                    @if (windowWidth <= 700) {
                      <p>
                        <strong
                          >{{ 'TABLE.ADD-USER.HEADER.LASTNAME' | translate }}:
                        </strong>
                        {{ element.lastName }}
                      </p>
                    }
                  </div>
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="
                let row;
                let index = dataIndex;
                columns: displayedColumns
              "
              class="element-row"
              [ngClass]="{ alternate: index % 2 === 0 }"></tr>
            <tr
              mat-row
              *matRowDef="
                let row;
                let index = dataIndex;
                columns: ['expandedDetail']
              "
              class="detail-row"
              [ngClass]="{ alternate: index % 2 === 0 }"></tr>
          </table>
          <div id="paginationContainer" class="pagination-container">
            <div>
              {{ 'TABLE.PAGINATION.PAGE' | translate }} {{ currentPage + 1 }}
            </div>
            <button
              (click)="onPreviousPageclick()"
              [disabled]="currentPageForView === 1">
              <mat-icon
                matTooltip="{{ 'TABLE.PAGINATION.PREVIOUSPAGE' | translate }}"
                >chevron_left</mat-icon
              >
            </button>
            <button (click)="onNextPageClick()" [disabled]="!hasMoreUsers">
              <mat-icon
                matTooltip="{{ 'TABLE.PAGINATION.NEXTPAGE' | translate }}"
                >chevron_right</mat-icon
              >
            </button>
          </div>
        </div>
      }
      @if (isBusyAffectingUsers) {
        <div class="loading" fxLayout="column" fxLayoutAlign="center center">
          <div fxFlex="100">
            <mat-progress-spinner
              [color]="spinner.color"
              [mode]="spinner.mode"
              [value]="spinner.value"
              [diameter]="spinner.diameter">
            </mat-progress-spinner>
          </div>
          <br />
          <div fxFlex="100">
            {{ 'ROLES.AFFECTUSERROLE.LOADING' | translate }}
          </div>
        </div>
      }
      @if (isError) {
        <div class="info-container" fxLayout="row" fxFill="100">
          <div class="message-box error user-created">
            <app-error-message [error]="error.error" />
          </div>
        </div>
      }
      @if (isSuccess) {
        <div class="info-container" fxLayout="row" fxFill="50">
          <div class="message-box success user-created">
            {{ 'ROLES.AFFECTUSERROLE.SUCCESS' | translate }}
          </div>
        </div>
      }
      @if (isSuccess) {
        <div class="row">
          <button
            mat-raised-button
            matStepperNext
            type="button"
            color="accent"
            class="btn-submit"
            (click)="matDialogRef.close()">
            {{ 'GENERAL.CONFIRMANDLEAVE' | translate }}
          </button>
        </div>
      }
      @if (!isSuccess) {
        <div class="row" class="button-container">
          <div fxFlex="50">
            <button
              mat-raised-button
              matStepperNext
              type="button"
              color="accent"
              class="btn-submit"
              (click)="affectUsers()"
              [disabled]="isBusyAffectingUsers">
              {{ 'ROLES.AFFECTUSERROLE.ADDBTN' | translate }}
            </button>
          </div>
          <div fxFlex="50" fxLayoutAlign="end">
            <button
              mat-raised-button
              matStepperNext
              type="button"
              color="warn"
              class="btn-submit"
              (click)="matDialogRef.close()"
              [disabled]="isBusyAffectingUsers">
              {{ 'GENERAL.CANCEL' | translate }}
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
